import { QuestionResponse } from '@app/resources/services';

export function isInstanceOfQuestionResponse(object: any): object is QuestionResponse {
  return 'questionId' in object;
}
